import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminLsaTeamAccounts = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/lsa/team_accounts/index.vue')
    createVueApp(IndexPage, { props })
  }
}
